import { createFileRoute } from '@tanstack/react-router'
import { requireModule, requirePermission } from '../../app/guards'
import { utilisationSearchSchema } from '../../features/reports/project-reports-search'
import { ProjectUtilisationPage } from '../../features/reports/project-utilisation-page'

export const Route = createFileRoute('/_app/project-utilisation')({
  staticData: { crumb: 'projectUtilisation' },
  validateSearch: utilisationSearchSchema,
  beforeLoad: ({ context }) => {
    requireModule(context.session, 'projects')
    requirePermission(context.session, 'projects.reports')
  },
  component: ProjectUtilisationPage,
})
